module.exports = __webpack_public_path__ + "img/delete.432542cf.svg";